import { Icon } from '@unite-us/ui';
import React from 'react';
export var SomethingWentWrong = function SomethingWentWrong() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center my-2"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconExclamationCircle",
    className: "fill-current text-red mr-1"
  }), /*#__PURE__*/React.createElement("p", null, "Something went wrong, we're looking into it..."));
};
//# sourceMappingURL=SomethingWentWrong.js.map